<template>
  <Modal
    v-model="_value"
    width="500"
    title='短信设置HIK"大亚湾"平台(通道5)'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">
    <p>确认发送短信：设置HIK大亚湾平台（通道5）</p>

  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setuphikdayabaysmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        simNum:null,

      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onOk() {
        //共三条短信，1、设置IP或域名。2、设置卡号。3、设置通道使能及协议
        // console.log(this.simNum.substring(6))
        store.dispatch('PositioningDeviceInfoServ_SearchByName',{
          params:{name:this.simNum.substring(6)},
          urlparams:{},
        }).then(res => {

          if (store.getters.get_PositioningDeviceInfo_SearchByNameResult.length >0){

          this.sendSMS('PlatParam:4,1,1,1,0,116.205.240.248,47016,'+ 0 + store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].terminalNum+ ',' + this.simNum.substring(6) +';A')

          }else {
            this.$Message.error('请检查主机号（卡号）')
          }
        }).catch(err => {
          console.log(err)
        })

      },
      sendSMS (content) {
        if (!this.simNum || this.simNum === '') {
          this.$Message.error('请选择SIM卡号')
          return
        }
        store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
